import src from "IMAGE";
export default { src, width: 1435, height: 746, blurWidth: 0, blurHeight: 0};
